import styled from "styled-components";

export const Wrapper = styled.div`
  .refresh-button {
  }
  .dailyreportfilter {
    justify-content: center;
    .filterinputbox {
      flex: auto !important;
      max-width: 25%;
    }
  }
  .loadingWrap {
    position: fixed;
    left: 50%;
    top: 183px;
  }
    .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-box {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
}
`;
